export default "__VITE_ASSET__CXLS$IhV__"